<template>
  <main class="main">
    <div class="buttons">
      <router-link :to="{ name: 'utilisateur-creation' }" custom v-slot="{ navigate }">
        <ButtonElement color="bordeaux" :icon="PhPlus" @click="navigate">
          Ajouter un utilisateur
        </ButtonElement>
      </router-link>
    </div>
    <div class="cards" v-if="utilisateurs.length">
      <CardComponent
        v-for="utilisateur in utilisateurs"
        :key="utilisateur.id"
        :icon="PhUser"
        :title="`${utilisateur.prenom} ${utilisateur.nom}${!utilisateur.actif ? ' (supprimé)' : ''}`"
        :transparent="!utilisateur.actif"
      >
        <template #buttons>
          <router-link
            :to="{ name: 'utilisateur-modification', params: { id: utilisateur.id } }"
            custom
            v-slot="{ navigate }"
          >
            <ButtonElement
              v-if="utilisateur.actif"
              color="bordeaux"
              :icon="PhPen"
              size="small"
              @click="navigate"
              >Modifier</ButtonElement
            >
          </router-link>
        </template>
        <CardInfoComponent title="Identifiant">{{ utilisateur.identifiant }}</CardInfoComponent>
      </CardComponent>
    </div>
    <div class="message" v-else>
      <PhWarning />
      <span>Aucun utilisateur n'est enregistré.</span>
    </div>
  </main>
</template>

<script setup lang="ts">
import { onMounted, ref, type Ref } from 'vue'
import type UtilisateurList from '@/interfaces/Utilisateur.ts'
import { PhPen, PhPlus, PhUser, PhWarning } from '@phosphor-icons/vue'
import ButtonElement from '@/components/ButtonElement.vue'
import CardComponent from '@/components/card/CardComponent.vue'
import CardInfoComponent from '@/components/card/CardInfoComponent.vue'
import { useLoadingStore } from '@/stores/loading.ts'
import { useCacheStore } from '@/stores/cache.ts'

const cacheStore = useCacheStore()
const loadingStore = useLoadingStore()

const utilisateurs: Ref<UtilisateurList[]> = ref([])

onMounted(async () => {
  loadingStore.start()
  try {
    utilisateurs.value = await cacheStore.getUtilisateurs()
  } finally {
    loadingStore.stop()
  }
})
</script>
